module.exports = __webpack_public_path__ + "static/img/mt4_platform.5637bc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/mt4_platform.png
// module id = eSiQ
// module chunks = 4